import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import * as queryString from 'query-string';
import {
  FollowUpKind,
  FollowUpModel,
  QqFollowUpModel,
} from '../model/FollowUpModel';

export default class FollowUpController extends AuthenticatedController {
  static getAll(botId: number) {
    const kinds = ['pending_follow_up', 'resolved_follow_up', 'qq_follow_up'];
    const q = queryString.stringify(
      { kinds },
      {
        arrayFormat: 'bracket',
      },
    );
    return super.get(APIRoutes.FOLLOW_UPS(botId, q));
  }

  static getByKind(botId: number, kind: FollowUpKind) {
    const q = queryString.stringify(
      { kinds: [kind] },
      {
        arrayFormat: 'bracket',
      },
    );
    return super.get(APIRoutes.FOLLOW_UPS(botId, q));
  }

  static putFollowUp(
    botId: number,
    id: number,
    entity: Partial<FollowUpModel<QqFollowUpModel>>,
    kind: FollowUpKind,
  ) {
    return super.put(APIRoutes.FOLLOW_UP(botId, id), { ...entity, kind });
  }
}
